// src/graphql/hooks.ts
import { useNovaGraphQL } from "./nova-graphql-provider.mjs";
import invariant from "invariant";
function useLazyLoadQuery(query, variables, options) {
  const graphql = useNovaGraphQL();
  invariant(
    graphql.useLazyLoadQuery,
    "Expected host to provide a useLazyLoadQuery hook"
  );
  return graphql.useLazyLoadQuery(query, variables, options);
}
function useFragment(fragmentInput, fragmentRef) {
  var _a, _b;
  return ((_b = (_a = useNovaGraphQL()).useFragment) == null ? void 0 : _b.call(_a, fragmentInput, fragmentRef)) || fragmentRef;
}
function useRefetchableFragment(fragmentInput, fragmentRef) {
  const graphql = useNovaGraphQL();
  invariant(
    graphql.useRefetchableFragment,
    "Expected host to provide a useRefetchableFragment hook"
  );
  return graphql.useRefetchableFragment(fragmentInput, fragmentRef);
}
function usePaginationFragment(fragmentInput, fragmentRef) {
  const graphql = useNovaGraphQL();
  invariant(
    graphql.usePaginationFragment,
    "Expected host to provide a usePaginationFragment hook"
  );
  return graphql.usePaginationFragment(fragmentInput, fragmentRef);
}
function useSubscription(config) {
  const graphql = useNovaGraphQL();
  invariant(
    graphql.useSubscription,
    "Expected host to provide a useSubscription hook"
  );
  graphql.useSubscription(config);
}
function useMutation(mutation) {
  const graphql = useNovaGraphQL();
  invariant(graphql.useMutation, "Expected host to provide a useMutation hook");
  return graphql.useMutation(mutation);
}
export {
  useFragment,
  useLazyLoadQuery,
  useMutation,
  usePaginationFragment,
  useRefetchableFragment,
  useSubscription
};
